import { Stack } from "@mui/material";
import React from "react";

interface IProps {
  children: React.ReactNode;
}

const StackWrapper: React.FC<IProps> = ({ children }) => {
  return <Stack rowGap="0.5rem">{children}</Stack>;
};

export default StackWrapper;
